import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PasswordStrengthMeter from '../components/PasswordStrengthMeter';
import './Auth.css';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();
  const { resetPassword } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [matchError, setMatchError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setMatchError('');
    if (password !== confirm) {
      setMatchError('Passwords do not match');
      return;
    }
    if (!token) {
      setError('Missing reset token. Open the link from your email.');
      return;
    }
    setLoading(true);
    const result = await resetPassword(token, password);
    setLoading(false);
    if (result.success) {
      setMessage(result.message);
      setTimeout(() => navigate('/login'), 2000);
    } else if (result.errorDetails && Array.isArray(result.errorDetails)) {
      setError(result.errorDetails.join('. '));
    } else {
      setError(result.error);
    }
  };

  if (!token && !message) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-brand">
            <img src="/tradelensy-logo.png" alt="Tradelensy logo" className="auth-logo" />
            <h1>Tradelensy</h1>
          </div>
          <h2>Reset password</h2>
          <div className="error-message">Missing reset token. Use the link from your email.</div>
          <p className="auth-link">
            <Link to="/forgot-password">Request a new link</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/tradelensy-logo.png" alt="Tradelensy logo" className="auth-logo" />
          <h1>Tradelensy</h1>
        </div>
        <h2>Choose a new password</h2>
        {message && (
          <div
            style={{
              padding: '12px',
              borderRadius: '4px',
              background: '#d4edda',
              color: '#155724',
              fontSize: '14px',
              marginBottom: '16px',
            }}
          >
            {message}
            <p className="auth-link" style={{ marginTop: '12px', marginBottom: 0 }}>
              <Link to="/login">Go to login</Link>
            </p>
          </div>
        )}
        {!message && (
          <>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>New password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  minLength={8}
                  maxLength={64}
                  autoComplete="new-password"
                />
                <PasswordStrengthMeter password={password} username="" email="" />
              </div>
              <div className="form-group">
                <label>Confirm password</label>
                <input
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  disabled={loading}
                  minLength={8}
                  maxLength={64}
                  autoComplete="new-password"
                />
                {matchError && (
                  <div className="error-message" style={{ marginTop: '8px', fontSize: '14px' }}>
                    {matchError}
                  </div>
                )}
              </div>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || password !== confirm || password.length < 8}
              >
                {loading ? 'Updating…' : 'Update password'}
              </button>
            </form>
          </>
        )}
        <p className="auth-link">
          <Link to="/login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}

export default ResetPassword;
